export const uuidCliente = 'uuidCliente'
export const clientes = 'clientes'
export const softwares = 'softwares'